<template>
  <div>
    <base-modal
      :showing="visible"
      size="max-w-lg"
      @close="$emit('close')"
      @opened="onOpened"
    >
      <base-card
        title="Promosi ke SC"
        :with-style="false"
        description="Lengkapi form dibawah ini untuk melakukan promosi"
      >
        <form class="space-y-4 border-t pt-5" @submit.prevent="onSubmit">
          <base-input
            fullwidth
            inset
            type="text"
            label="Kode SC"
          >
            <div class="flex items-center gap-1 mt-1">
              <span class="text-sm text-gray-600">SC</span>
              <input type="text" class="w-full p-0 border-0 placeholder-gray-200 text-sm focus:ring-0" placeholder="Masukkan kode kantor (Contoh SC1)" required v-model="form.code">
            </div>
          </base-input>
          <base-input
            fullwidth
            inset
            type="text"
            label="Email"
            required
            placeholder="Masukkan email (Contoh sc1@nasa.com)"
            v-model="form.email"
          />
          <base-input
            fullwidth
            inset
            type="text"
            label="No. Account GL"
            placeholder="Masukkan no account gl (Contoh 989231933)"
            v-model="form.no_account_gl"
          />
          <base-input
            fullwidth
            inset
            type="text"
            label="Cost Center"
            placeholder="Masukkan no cost center"
            v-model="form.cost_center"
          />
          <div class="grid grid-cols-2 gap-2">
            <base-button fullwidth>Promosi</base-button>
            <base-button
              type="button"
              fullwidth
              color="light"
              @click="$emit('close')"
              >Tutup</base-button
            >
          </div>
        </form>
      </base-card>
    </base-modal>
    <loading v-if="loading" />
  </div>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import BaseModal from '@/components/base/BaseModal.vue';
import { mapActions } from 'vuex';

export default {
  mixins: [requestMixin],
  components: { BaseModal },
  props: {
    visible: Boolean,
    officeId: String,
  },
  emits: ['close', 'promoted'],
  data() {
    return {
      form: {
        code: null,
        email: null,
        no_account_gl: null,
        cost_center: null,
      },
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    onOpened() {
      this.form.code = null;
      this.form.email = null;
      this.form.no_account_gl = null;
      this.form.cost_center = null;
    },
    async onSubmit() {
      this.loading = true;

      const [, err] = await this.request(
        `/api/v1/offices/${this.officeId}/-actions/promoteToSC`,
        {
          method: 'post',
          data: {
            data: {
              attributes: this.form,
            },
          },
        }
      );

      if (err) {
        this.createAlert({
          data: this.getRequestErrorMessage(err),
          status: 'error',
        });
      } else {
        this.$emit('promoted');
      }

      this.loading = false;
    },
  },
};
</script>
